import { isInBrowser } from './isInBrowser.js';
import { _global } from './unils.js';

const DEJAVU_REPORT_KEY = '_BiliGreyResult';
/**
 * 获取dejavu-发布,灰度相关版本信息&离线包信息
 * @returns
 */
const getDejavuVersionData = () => {
    if (!isInBrowser())
        return {};
    if (!_global[DEJAVU_REPORT_KEY])
        return {};
    const Obj = _global[DEJAVU_REPORT_KEY];
    var res = {};
    Object.entries(Obj).forEach(([key, value]) => {
        res[`${DEJAVU_REPORT_KEY}_${key}`] = value;
    });
    const offlineData = getOfflineMetaData();
    return Object.assign(Object.assign({}, res), offlineData);
};
const getOfflineMetaData = () => {
    const offlineVersion = getHtmlMetaContent('offline-version');
    const offlineName = getHtmlMetaContent('offline-name');
    const offlinePlat = getHtmlMetaContent('offline-plat');
    const offlineType = getHtmlMetaContent('offline-type');
    if (offlineVersion) {
        return { offlineVersion, offlineName, offlinePlat, offlineType };
    }
    else {
        return {};
    }
};
const getHtmlMetaContent = name => {
    var _a;
    return ((_a = document.getElementsByTagName('meta')[name]) === null || _a === void 0 ? void 0 : _a.content) || undefined;
};

export { getDejavuVersionData };
